import { createRequestHelper } from '@utils/swr'
import { type CrossBrandMallHomeDetailRequest } from '../types/apiRequest'
import { type CrossBrandMallHomeDetailResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['crossBrandMallHomeDetail'], CrossBrandMallHomeDetailResponse, CrossBrandMallHomeDetailRequest>({
  client: 'fortune',
  key: params => params?.mall_code ? `/cross-brand-malls/${params.mall_code}` : null,
  isImmutable: true,
})

export const useApiCrossBrandMallHomeDetail = useRequest
